import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge", "background"]

  connect() {
    this.backgroundTarget.classList.remove("scale-[30%]")
    window.addEventListener("scroll", this.rollOnScroll.bind(this))
  }

  rollOnScroll() {
    const scrollY = window.scrollY
    this.roll(scrollY)
  }

  roll(scrollY) {
    const speedFactor = 3
    const rotation = (scrollY / speedFactor) % 360
    this.badgeTarget.style.transform = `rotate(${rotation}deg)`
  }
}
